import Builder, { initialValues as builderInitialValues } from './Builder';
import Player from './Player';

export default {
    handle: 'chronicConditions',
    label: 'Chronic Conditions',
    builderInitialValues,
    builder: Builder,
    player: Player,
};
